
<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <li class="giga-action_item">
    <div class="giga-button hasDropdown"  :class="{'active-filter_dropdown' : toggleActionsDropdown}">
      <button class="giga-gray_button with-icon" @click="toggleDropdown()">
        <i class="giga-icon">
          <svg class="fill" width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg" >
            <path d="M0.692308 3.57143H4.22308C4.5 4.78571 5.60769 5.71429 6.92308 5.71429C8.23846 5.71429 9.27692 4.78571 9.62308 3.57143H17.3077C17.7231 3.57143 18 3.28571 18 2.85714C18 2.42857 17.7231 2.14286 17.3077 2.14286H9.62308C9.34615 0.928571 8.23846 0 6.92308 0C5.60769 0 4.56923 0.928571 4.22308 2.14286H0.692308C0.276923 2.14286 0 2.42857 0 2.85714C0 3.28571 0.276923 3.57143 0.692308 3.57143Z" fill="#132D48" />
            <path d="M17.3077 9.28568H14.4692C14.1923 8.07139 13.0846 7.14282 11.7692 7.14282C10.4538 7.14282 9.41539 8.07139 9.06923 9.28568H0.692308C0.276923 9.28568 0 9.57139 0 9.99996C0 10.4285 0.276923 10.7143 0.692308 10.7143H9.06923C9.34615 11.9285 10.4538 12.8571 11.7692 12.8571C13.0846 12.8571 14.1231 11.9285 14.4692 10.7143H17.3077C17.7231 10.7143 18 10.4285 18 9.99996C18 9.57139 17.7231 9.28568 17.3077 9.28568Z" fill="#132D48" />
            <path d="M17.3077 16.4285H9.62308C9.34615 15.2142 8.23846 14.2856 6.92308 14.2856C5.60769 14.2856 4.56923 15.2142 4.22308 16.4285H0.692308C0.276923 16.4285 0 16.7142 0 17.1428C0 17.5714 0.276923 17.8571 0.692308 17.8571H4.22308C4.5 19.0714 5.60769 19.9999 6.92308 19.9999C8.23846 19.9999 9.27692 19.0714 9.62308 17.8571H17.3077C17.7231 17.8571 18 17.5714 18 17.1428C18 16.7142 17.7231 16.4285 17.3077 16.4285Z" fill="#132D48" />
          </svg>
        </i>
        <span>
        <label>{{ validFilters.length }}</label> Filtre</span>
      </button>
      <div class="giga-filter_dropdown">
        <div class="giga-filter_dropdown_header">
          <!-- <h3 class="giga-filter_dropdown_title">Modifier le type de document</h3> -->
          <button class="giga-filter_dropdown_close" @click="closeDropdown()">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.256 8L15.52 2.736C15.824 2.448 16 2.048 16 1.6C16 0.72 15.28 0 14.4 0C13.952 0 13.552 0.176 13.264 0.464L8 5.744L2.736 0.464C2.448 0.176 2.048 0 1.6 0C0.72 0 0 0.72 0 1.6C0 2.048 0.176 2.448 0.464 2.736L5.744 8L0.48 13.264C0.176 13.552 0 13.952 0 14.4C0 15.28 0.72 16 1.6 16C2.048 16 2.448 15.824 2.736 15.536L8 10.256L13.264 15.52C13.552 15.824 13.952 16 14.4 16C15.28 16 16 15.28 16 14.4C16 13.952 15.824 13.552 15.536 13.264L10.256 8Z" fill="#6B829A"/>
            </svg>

          </button>
        </div>

        <!-- DROPDOWN -->
        <div class="giga-filter_dropdown_body">
          <div class="giga-fitler_list">

            <!-- ROWS -->
            <div
              class="giga-fitler_row"
              v-for="filter in filters"
              :key="filter.id"
            >
              <filter-element
                :config="queryConfig"
                :filter="filter"
              ></filter-element>

              <div class="giga-button">
                <b-button
                  class="only-icon giga-remove_button"
                  @click="removeFilter(filter.id, false)"
                >
                  <b-icon icon="trash" font-scale="1.2"></b-icon>
                </b-button>
              </div>

            </div>
          </div>
          
          <div class="giga-button">
            <b-button
              class="giga-no_bg_button"
              @click="addFilter()"
              ><b-icon icon="plus" class="mr-2"></b-icon
              >{{ $t("add_filter") }}</b-button
            >
          </div>
          <div class="giga-filter_dropdown_footer">
            <div class="giga-button">
              <b-button
                @click="resetFilter()"
                class="giga-blue_outlined_button no-icon"
                >{{ $t("reset_filter") }}</b-button
              >
            </div>
            <div class="giga-button">
              <b-button
                @click="submitFilter()"
                class="giga-green_button no-icon"
              >
                <span> {{ $t("apply") }}</span>
              </b-button>
            </div>
          </div>
        </div>
        <!-- END DROPDOWN -->
      </div>
    </div>

<!--    <div v-if="isFilterNotEmpty()" class="text-center text-md-left flex-1">-->
<!--      <div class=" filter_tags d-flex flex-column flex-md-row align-items-center justify-content-start">-->
<!--        <div v-if="validFilters.length">-->
<!--          <small class="mr-2 font-weight-light text-nowrap" >{{ $t("filters_active") }}:</small>-->
<!--        </div>-->
<!--        <div-->
<!--          class="tags-border filter-tags-with-scroll mr-lg-3"-->
<!--          v-if="validFilters.length"-->
<!--        >-->
<!--          <VuePerfectScrollbar>-->
<!--            <div class="filter-tags-wrap-with-scroll">-->
<!--              <template v-for="data in validFilters">-->
<!--                <span-->
<!--                  :key="data.id"-->
<!--                  v-if="data && data.query && data.value"-->
<!--                  class="filter_tag mx-2 my-2"-->
<!--                >-->
<!--                  <small class="font-weight-light">-->
<!--                    {{-->
<!--                      "'" + data.query.name + "' '" + data.operator.value + "' "-->
<!--                    }}-->
<!--                    <template-->
<!--                      v-if="-->
<!--                        data.query.type === 'select' ||-->
<!--                        data.query.type === 'multiselect'-->
<!--                      "-->
<!--                    >-->
<!--                      {{ "'" + joinSelectValues(data.value) + "'" }}-->
<!--                    </template>-->
<!--                    <template v-else>-->
<!--                      {{ "'" + data.value + "'" }}-->
<!--                    </template>-->
<!--                  </small>-->
<!--                  <span-->
<!--                    class="icon text-danger"-->
<!--                    @click="removeFilter(data.id, true)"-->
<!--                  >-->
<!--                    <b-icon icon="x" class="icon-close"></b-icon>-->
<!--                  </span>-->
<!--                </span>-->
<!--              </template>-->
<!--            </div>-->
<!--          </VuePerfectScrollbar>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--    <b-modal-->
<!--      id="filter"-->
<!--      modal-class="p-4 big-modal modal-scroll"-->
<!--      content-class="text-center pb-2"-->
<!--      no-close-on-esc-->
<!--      no-close-on-backdrop-->
<!--      hide-header-->
<!--      hide-footer-->
<!--      lazy-->
<!--    >-->
<!--      <b-icon-->
<!--        icon="x"-->
<!--        @click="hideModalFilter()"-->
<!--        class="icon-close fsize-5 text-muted"-->
<!--      ></b-icon>-->

<!--      <div class="py-2">-->
<!--        <h2 class="text-primary mb-4 mt-2 pt-5 font-45px">-->
<!--          {{ $t(headerTitle) }}-->
<!--        </h2>-->
<!--        <b-row class="d-flex justify-content-center">-->
<!--          <b-col cols="9">-->
<!--            <b-card-->
<!--              class="border-raduis-xl border-color-muted box-shadow-sm"-->
<!--              body-class="py-4 p-sm-4"-->
<!--            >-->
<!--              <b-row class="mb-4">-->
<!--                <b-col-->
<!--                  md="12"-->
<!--                  class="d-flex align-items-end justify-content-end"-->
<!--                >-->
<!--                  <b-button-->
<!--                    @click="addFilter()"-->
<!--                    pill-->
<!--                    size="sm"-->
<!--                    variant="outline-primary"-->
<!--                    class="px-4 text-nowrap mr-2"-->
<!--                    ><b-icon icon="funnel-fill" class="mr-2"></b-icon-->
<!--                    >{{ $t("add_filter") }}</b-button-->
<!--                  >-->
<!--                  <b-button-->
<!--                    @click="resetFilter()"-->
<!--                    pill-->
<!--                    size="sm"-->
<!--                    variant="outline-primary"-->
<!--                    class="px-4 text-nowrap mr-2"-->
<!--                    ><b-icon icon="arrow-counterclockwise" class="mr-2"></b-icon-->
<!--                    >{{ $t("reset_filter") }}</b-button-->
<!--                  >-->
<!--                </b-col>-->
<!--              </b-row>-->
<!--              <VuePerfectScrollbar class="scroll-area">-->
<!--                <template>-->
<!--                  <div-->
<!--                    class="-->
<!--                      filter-field-->
<!--                      d-flex-->
<!--                      align-items-center-->
<!--                      justify-content-center-->
<!--                      mb-4-->
<!--                      px-3-->
<!--                    "-->
<!--                    v-for="filter of filters"-->
<!--                    :key="filter.id"-->
<!--                  >-->
<!--                    <filter-element-->
<!--                      :config="queryConfig"-->
<!--                      :filter="filter"-->
<!--                    ></filter-element>-->
<!--                    <b-button-->
<!--                      @click="removeFilter(filter.id, false)"-->
<!--                      variant="outline-primary"-->
<!--                      size="sm"-->
<!--                      class="ml-3 p-2"-->
<!--                    >-->
<!--                      <b-icon icon="trash" font-scale="1.2"></b-icon>-->
<!--                    </b-button>-->
<!--                  </div>-->
<!--                  <p class="error text-danger fsize-1" v-if="!isFilterValid">-->
<!--                    {{ $t("filter_not_valid_message") }}-->
<!--                  </p>-->
<!--                </template>-->
<!--              </VuePerfectScrollbar>-->
<!--            </b-card>-->
<!--            <b-card-->
<!--              class="border-raduis-xl border-color-muted box-shadow-sm mt-4"-->
<!--              body-class="p-3"-->
<!--            >-->
<!--              <b-row>-->
<!--                <b-col cols="12" sm="6" class="text-sm-right mb-2 mb-sm-0">-->
<!--                  <b-button-->
<!--                    @click="hideModalFilter()"-->
<!--                    pill-->
<!--                    variant="outline-primary"-->
<!--                    class="py-2 px-5"-->
<!--                  >-->
<!--                    <span>{{ $t("cancel") }}</span>-->
<!--                  </b-button>-->
<!--                </b-col>-->
<!--                <b-col cols="12" sm="6" class="text-sm-left">-->
<!--                  <b-button-->
<!--                    @click="submitFilter()"-->
<!--                    pill-->
<!--                    variant="primary"-->
<!--                    class="py-2 px-5"-->
<!--                  >-->
<!--                    <span> {{ $t("apply") }}</span>-->
<!--                  </b-button>-->
<!--                </b-col>-->
<!--              </b-row>-->
<!--            </b-card>-->
<!--          </b-col>-->
<!--        </b-row>-->
<!--      </div>-->
<!--    </b-modal>-->
  </li>
</template>

<script>
import FilterElement from "./FilterElement";
import { uuid } from "vue-uuid";
import { queryConstant } from "@/shared/queryConstant";
import { map } from "lodash";
import moment from "moment";

export default {
  name: "FilterModal",
  components: { FilterElement },
  props: ["queryConfig", "headerTitle", "openModal", "currentFilter"],
  data() {
    return {
      locale: "fr",
      filters: [],
      nFilter: 0,
      validFilters: [],
      customFilter: queryConstant.setDefaultCustomFilter(),
      isFilterValid: true,
      toggleActionsDropdown: false
    };
  },
  computed: {},
  mounted(){
    if (this.currentFilter && this.currentFilter.length) {
      this.isFilterValid = true;
      this.filters = JSON.parse(JSON.stringify(this.currentFilter));
    } else {
      this.firstFilterRow();
    }
  },
  methods: {
    firstFilterRow() {
      this.filters.push({
        id: uuid.v4(),
        query: null,
        operator: null,
        value: null,
      });
    },
    submitFilter() {
      this.isFilterValid = true;
      this.filters.forEach((filter) => {
        if (
          (filter.value instanceof Array && filter.value.length === 0) ||
          !filter.value
        ) {
          this.isFilterValid = false;
        }
      });
      if (this.isFilterValid) {
        this.validFilters = JSON.parse(JSON.stringify(this.filters));
        this.closeDropdown();
        const customFilter = queryConstant.setDefaultCustomFilter();
          this.filters.forEach((filter) => {
          if (
            filter.query.type === "select" ||
            filter.query.type === "multiselect"
          ) {
            if (filter.query.custom) {
              customFilter.rules.push(this.setCustomMultiSelectRule(filter));
            } else {
              customFilter.rules.push(this.setDefaultMultiSelectRule(filter));
            }
          } else {
            customFilter.rules.push(this.setDefaultRule(filter));
          }
        });
        this.customFilter = customFilter;
        console.log('customFilter', customFilter);
        this.$emit("onFilter", {
          filters: this.validFilters,
          custom: this.customFilter,
        });
        // this.nFilter++
      }
    },
    setDefaultRule(filter) {
      return {
        id: filter.id,
        field: filter.query.element,
        operator: filter.operator.key,
        custom: filter.query.custom,
        value:
          filter.query.type === "date"
            ? moment(filter.value).format("x")
            : filter.value,
        typeQuery: filter.query.entity,
      };
    },
    setDefaultMultiSelectRule(filter) {
      const selectRules = {
        id: filter.id,
        condition: "OR",
        operator: filter.operator.key,
        field: filter.query.element,
        custom: filter.query.custom,
        value: null,
        rules: [],
      };
      if(Array.isArray(filter.value)){
        filter.value.forEach((rule) => {
          selectRules.rules.push({
            id: filter.id,
            field: filter.query.element,
            operator: filter.operator.key,
            value: rule.value,
            typeQuery: "enum",
          });
        });
      }
      else{
        selectRules.rules.push({
          id: filter.id,
          field: filter.query.element,
          operator: filter.operator.key,
          value: filter.value.value,
          typeQuery: "enum",
        });
      }
      return selectRules;
    },
    setCustomMultiSelectRule(filter) {
      return {
        id: filter.id,
        field: filter.query.element,
        operator: filter.operator.key,
        custom: filter.query.custom,
        value: map(filter.value, "value"),
        typeQuery: filter.query.entity,
      };
    },
    addFilter() {
      this.filters.push({
        id: uuid.v4(),
        query: null,
        operator: null,
        value: null,
      });
    },
    removeFilter(id, reload) {
      this.filters = this.filters.filter((f) => f.id !== id);
      if (reload) {
        this.validFilters = this.validFilters.filter((f) => f.id !== id);
        const filter = queryConstant.setDefaultCustomFilter();
        filter.rules = this.customFilter.rules.filter((f) => f.id !== id);
        this.customFilter = filter;
        this.$emit("onReloadData", {
          filters: this.filters,
          custom: this.customFilter,
        });
      }
    },
    resetFilter() {
      this.filters = [];
      this.validFilters = [];
      this.isFilterValid = true;
    },
    toggleDropdown(){
      this.toggleActionsDropdown = !this.toggleActionsDropdown;
    },
    closeDropdown(){
      this.toggleActionsDropdown = false;
    },
  },
};
</script>
<style lang='scss'>
.scroll-area {
  margin: auto;
  max-height: 200px;
}
.filter_tags {
  position: relative;
  width: 100%;
}
.filter-tags-with-scroll {
  position: relative;
  width: 200px;
  flex: 100%;
}
.filter-tags-wrap-with-scroll {
  white-space: nowrap;
  display: inline-flex;
}
.flex-1 {
  flex: 1;
}
.flex-100 {
  flex: 100%;
}
/*b-form-select class*/
.custom-select {
  height: calc(1.5em + 0.75rem + 2px);
}
</style>
